<template>
  <el-dialog
    :visible="centerDialogVisible"
    top="150px"
    :modal-append-to-body="false"
    :show-close = "false"
    center
    class="main-dialog">
    <i class="el-icon-close dialog-close" @click="cancel"></i>
    <p class="passw-title">输入密钥</p>
    <p class="passw-msg">密钥藏在【学前必读】里，赶快去寻找吧!</p>
    
    <div class="input-box">
      <p class="prompt-text">{{promptText}}</p>
      <input class="passw-inp" autofocus="autofocus" type="text" v-model="password" @keyup.enter="clickOk">
      <p class="pass-btn" @click="clickOk">确定</p>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: "CenterDialog",
  props: {
    centerDialogVisible: Boolean,
    classList: Object
  },
  data () {
    return {
      password: "",
      promptText: ""
    }
  },
  inject: ['reload'],
  components: {
  },
  methods: {
    cancel () {
      this.$emit('update:centerDialogVisible', false);
      this.promptText = "";
    },
    clickOk () {
      // console.log(this.classList._id)
      this.axios.post(`/unlock?package=${this.classList._id}`).then((res) => {
        console.log('00-----------------');
        this.cancel();
        this.$router.go(0);

      }).catch((error) => {
        console.log(error);
      });

      // this.$emit("classUnlock", this.password);
      // console.log(this.clickLiIndex);
      // if(this.password == "12345"){
      //   this.$emit("classUnlock");
      //   this.cancel();
      // }else{
      //   this.promptText = "哎呀，密钥好像不对呦，返回重新寻找吧！"
      // }
    }
  }
};
</script>

<style lang="scss" scoped>
.passw-title{
  color: #F2BE46;
  font-size: 20px;
  text-align: center;
  margin: 130px 0 30px;
}

.passw-msg{
  color: #535353;
  font-size: 14px;
  text-align: center;
}

.dialog-close{
  width: 40px;
  height: 40px;
  line-height: 40px;
  position: absolute;
  top: 100px;
  right: 65px;
  background-color: #fff;
  border-radius: 50%;
  color: #A179F9;
  text-align: center;
  font-size: 20px;
  &:hover {
    background-color: #e44b19;
  }
}

.input-box{
  display: flex;
  margin-top: 53px;
  position: relative;
  .passw-inp{
    width: 170px;
    height: 28px;
    margin-left: 63px;
    border-radius: 6px;
    background-color: #956fe8;
    border: 0 none;
    color: #fff;
    padding-left: 6px;
  }
  .pass-btn{
    width: 32px;
    height: 32px;
    line-height: 32px;
    font-size: 12px;
    color: #fff;
    background-color: #F1B934;
    border-radius: 50%;
    text-align: center;
    margin-left: 20px;
    cursor: pointer;
    &:hover {
      background-color: #e44b19;
    }
  }
  .prompt-text{
    color: red;
    font-size: 12px;
    padding: 10px 50px;
    position: absolute;
    left: 10px;
    top: -50px;
  }
}

.main-dialog {
  width: 400px;
  height: 400px;
  background-color: transparent !important;
  background-image: url("~@/assets/images/main_dialog.png");
  background-size: contain; 
  box-shadow: none;
}

</style>

<style>

</style>

